var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"app"}},[_c('v-main',[_c('router-view')],1),(_vm.showFooter)?_c('PageFooter'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }